let darkBasic = '#1D2029';
let darkDarken = '#16181D';
let darkLighten = '#2C313A';
let darkHover = '#282C34';
let darkSecondary = '#AAA';
let darkBorderColor = '#000';
let accentColor = '#2fabfc';
let accentColorHover = '#7fccff';
let accentColorActiveHover = '#395c74';
export const THEMES = {
    dark: {
        /*****************************
            variables.css
  *******************************/ /* General */ '--vl_accent_color': accentColor,
        '--vl_accent_color-hover': accentColorHover,
        '--vl_accent_bgColor-activeHover': darkHover,
        '--vl_accent_bgColor-hover': darkHover,
        '--vl_content_bgColor': darkBasic,
        '--vl_borderColor': darkBorderColor,
        '--vl_div_bgColor': darkDarken,
        '--vl_divSecondary_borderColor': darkBorderColor,
        '--vl_divSecondary_bgColor': darkLighten,
        '--vl_divSecondary_bgColor-hover': darkHover,
        /* Backend Styles */ '--vl_adminHeader_boxShadowColor': darkDarken,
        /* Fonts */ '--vl_body_color': '#EEE',
        '--vl_bodySecondary_color': darkSecondary,
        /* Menu */ '--vl_menu_item_bgColor-hover': darkHover,
        '--vl_menu_item_bgColor-active': darkDarken,
        /* Lists */ '--vl_listRow_bgColor-hover': darkHover,
        '--vl_listRow_bgColor-active': darkDarken,
        /* Tree */ '--tree_bgColor': darkBasic,
        /* Mark */ '--vl_mark_bgColor': accentColorActiveHover,
        '--vl_mark_positve_bgColor': '#549527',
        '--vl_mark_positve2_bgColor': '#305913',
        '--vl_mark_neutral_bgColor': '#3e4949',
        '--vl_mark_inactive_bgColor': '#4d4d4d',
        '--vl_mark_negative_bgColor': '#b32828',
        '--vl_mark_negative2_bgColor': '#651b1b',
        '--vl_mark_negative3_bgColor': '#571212',
        '--vl_mark_negative3_bgColor': '#571212',
        /* Splitter */ '--vl_layout_splitter_bgColor': darkDarken,
        '--vl_splitter_borderColor': darkLighten,
        /* Scrollbar */ '--vl_scrollbar_thumb_bgColor': darkLighten,
        /* Title Grid */ '--titleGrid_showcase_bgColor': '#0a0c10',
        /*****************************
            semanticUI.css
  *******************************/ '--sui_transparent15': 'rgba(255, 255, 255, 0.15)',
        '--sui_transparent05': 'rgba(255, 255, 255, 0.05)',
        '--sui_transparent40': 'rgba(255, 255, 255, 0.4)',
        '--sui_transparent60': 'rgba(255, 255, 255, 0.60)',
        '--sui_transparent80': 'rgba(255, 255, 255, 0.80)',
        '--sui_transparent87': 'rgba(255, 255, 255, 0.87)',
        '--sui_transparent95': 'rgba(255, 255, 255, 0.95)',
        '--sui_disabled': 'rgba(215, 215, 215, 0.3)',
        '--sui_background_transparent03': 'rgba(255, 255, 255, 0.02)',
        '--sui_table_th_bgColor': darkDarken,
        '--sui_breadcrumb_color': darkSecondary,
        '--sui_buttonGrey_bgColor': darkLighten,
        '--sui_buttonGrey_bgColor-hover': darkHover,
        '--sui_buttonGrey_bgColor-active': darkDarken,
        '--sui_buttonGrey_color-active': accentColor,
        /*****************************
            modules/workshops
    *******************************/ '--workshop_link_color': '#d6bddd',
        '--workshop_link_color-hover': '#8f669b',
        '--workshop_btn_bgColor-hover': '#c0992c20',
        '--workshop_body_color': '#d3d3d3',
        '--workshop_base_bgColor': '#121212',
        '--workshop_div-hover': '#996d3820',
        '--workshop_secondary_div': '#1e1e1e',
        '--workshop_border': '#333333',
        '--workshop_boxshadow': '2px 5px 15px rgba(0, 0, 0, 0.5)'
    }
};
